import { ItemCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/inventory/v1/item_events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

type ItemCreatedDetailProps = {
  event: ItemCreatedEvent;
};

export const ItemCreatedDetail = ({ event }: ItemCreatedDetailProps) => {
  const item = event.item;

  if (!item) {
    return (
      <Col className="@ItemCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const attributeValues = item.attributeValues ?? {};
  const hasAttributeValues = Object.keys(attributeValues).length > 0;

  return (
    <Col className="@ItemCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Item Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={item.id?.value} />
          <FieldDisplay label="Name" value={item.name} />
          <FieldDisplay label="SKU Number" value={item.skuNumber} />
          <IDField label="Category ID" value={item.categoryId?.value} />
          <IDField label="Item Group ID" value={item.itemGroupId?.value} />
          <FieldDisplay label="Description" value={item.description} />
          <FieldDisplay label="Notes" value={item.notes} />
        </div>
      </Col>
      {hasAttributeValues && (
        <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
          <span className="text-xs font-medium text-neutral/60">
            Attribute Values
          </span>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            {Object.entries(attributeValues).map(([key, value]) => (
              <FieldDisplay
                key={key}
                label={key}
                value={JSON.stringify(value)}
              />
            ))}
          </div>
        </Col>
      )}
    </Col>
  );
};
